import React from "react";
import APPCONFIG from "constants/Config";
import isoFooter from 'assets/images/iso-footer.png';

class Footer extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <section className="app-footer">
        <div className="container-fluid" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <span className="float-left">
            <img src={isoFooter} alt="ISO 9001 Certified" className="iso-footer-img" style={{ height: 30, marginRight: 10, verticalAlign: 'bottom' }} />
          </span>
          <span className="float-right">
            <span>
              Copyright ©{" "}
              <a className="brand" target="_blank" href={APPCONFIG.productLink}>
                {APPCONFIG.brand}
              </a>{" "}
              {APPCONFIG.year}
            </span>
            {/* <span>
              Developed by{" "}
              <a
                className="brand"
                target="_blank"
                href="https://www.pixel38.com"
              >
                Pixel38
              </a>{" "}
              with Love <i className="material-icons">favorite_border</i>
            </span> */}
          </span>
        </div>
      </section>
    );
  }
}

export default Footer;
